import request from "@/utils/request";

// 用户注册
export function register(userData) {
  return request({
    url: "/user/register",
    method: "post",
    data: userData,
  });
}

// 用户登录
export function login(username, password) {
  return request({
    url: "/user/login",
    method: "post",
    data: {
      username: username,
      password: password,
    },
  });
}

// 手机验证码登录
export function loginWithPhone(phone, code) {
  return request({
    url: "/user/login/phone",
    method: "post",
    data: {
      phone: phone,
      code: code,
    },
  });
}

// 发送手机验证码
export function sendPhoneCode(phone) {
  return request({
    url: "/user/send-phone-code",
    method: "post",
    data: { phone: phone },
  });
}

// 发送邮箱验证码（登录态，用于安全设置邮箱验证）
export function sendVerifyEmailCode(email) {
  return request({
    url: "/user/send-email-code",
    method: "post",
    data: { email },
  });
}
// 验证邮箱（登录态，用于安全设置）
export function verifyEmail(code) {
  return request({
    url: "/user/verify-email",
    method: "post",
    data: { code },
  });
}

// 发送邮箱验证码（密码找回）
export function sendEmailCode(email) {
  return request({
    url: "/user/send-email-code-reset",
    method: "post",
    data: { email },
  });
}

// 验证邮箱验证码
export function verifyEmailCode(data) {
  return request({
    url: "/user/verify-email-code",
    method: "post",
    data,
  });
}

// 重置密码
export function resetPassword(data) {
  return request({
    url: "/user/reset-password",
    method: "post",
    data,
  });
}

// 获取当前用户信息
export function getCurrentUser() {
  return request({
    url: "/user/me",
    method: "get",
  });
}

// 获取用户中心数据
export function getUserDashboard(userId) {
  return request({
    url: "/user/dashboard",
    method: "get",
    params: {
      user_id: userId,
    },
  });
}

// 更新用户信息
export function updateUserProfile(userData) {
  return request({
    url: "/user/profile/update",
    method: "post",
    data: userData,
  });
}

// 第三方登录
export function bindDeviceForThirdP(params) {
  return request({
    url: "/user/device/bindThirdP",
    method: "post",
    data: params,
  });
}

// 绑定设备
export function bindDevice(deviceData) {
  return request({
    url: "/user/device/bind",
    method: "post",
    data: deviceData,
  });
}

// 解绑设备
export function unbindDevice(userId, deviceId) {
  return request({
    url: "/user/device/unbind",
    method: "post",
    data: {
      user_id: userId,
      device_id: deviceId,
    },
  });
}

// 验证设备授权
export function verifyDevice(userId, deviceId) {
  return request({
    url: "/user/device/verify",
    method: "post",
    data: {
      user_id: userId,
      device_id: deviceId,
    },
  });
}

// 修改密码
export function changePassword(passwordData) {
  return request({
    url: "/user/password/change",
    method: "post",
    data: passwordData,
  });
}

// 上传头像
export function uploadAvatar(formData) {
  return request({
    url: "/user/avatar/upload",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    timeout: 30000, // 上传超时时间
  });
}

// 检查用户授权状态
export function checkUserLicenseStatus() {
  return request({
    url: "/user/license-status",
    method: "get",
  });
}

// 检查用户是否有有效授权
export function hasValidLicense() {
  return request({
    url: "/user/has-valid-license",
    method: "get",
  });
}
